(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/active-member-panel.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/active-member-panel.js');
'use strict';

const {
  GridRow
} = svs.ui.ReactGrid;
const {
  ActiveGames,
  NewGame,
  TransactionInput
} = svs.arena.pages.teams.components;
const {
  memberRoles
} = svs.arena.constants;
const {
  MemberAccordion
} = svs.arena.pages.teams.components;
const ActiveMemberPanel = _ref => {
  let {
    team,
    onTransactionSuccess
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(GridRow, {
    className: "padding-h-1"
  }, React.createElement(ActiveGames, {
    teamId: team === null || team === void 0 ? void 0 : team.syndicateId
  })), (team === null || team === void 0 ? void 0 : team.activeMemberCount) > 1 && team.playableAmount !== '0,00' && React.createElement(GridRow, {
    className: "padding-h-1",
    gutter: "0"
  }, !(team !== null && team !== void 0 && team.adminManagedWagers) && React.createElement(NewGame, {
    teamId: team.syndicateId
  }), (team === null || team === void 0 ? void 0 : team.adminManagedWagers) && (team === null || team === void 0 ? void 0 : team.memberRole) !== memberRoles.NORMAL && React.createElement(NewGame, {
    teamId: team.syndicateId
  }), (team === null || team === void 0 ? void 0 : team.adminManagedWagers) && (team === null || team === void 0 ? void 0 : team.memberRole) === memberRoles.NORMAL && React.createElement("div", {
    className: "padding-top-1 f-center"
  }, "Endast lagledaren och spell\xE4ggare kan l\xE4gga spel f\xF6r laget.")), React.createElement(MemberAccordion, {
    team: team,
    teamId: team === null || team === void 0 ? void 0 : team.syndicateId
  }), React.createElement(GridRow, {
    className: "padding-h-1"
  }, React.createElement(TransactionInput, {
    myTeamAmount: team === null || team === void 0 ? void 0 : team.memberBalance,
    onSuccess: onTransactionSuccess,
    teamId: team === null || team === void 0 ? void 0 : team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  })));
};
svs.arena.pages.teams.components.ActiveMemberPanel = ActiveMemberPanel;

 })(window);